import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./Footer.css"

class Footer extends Component {

    render() {
        return (
          <div id="footer-section">
            <div className="footer-wrapper">
              <section className="footer-brand-section">
                <div className="footer-brand-content">
                  <h1 className="footer-brand-title">Alisar Prospects Training</h1>
                  <p className="footer-brand-tagline">Empowering Communities, Building Futures Together</p>
                  <div className="footer-brand-description">
                    Supporting London's communities since 2013 with education, employment, 
                    advocacy, and family services.
                  </div>
                  <div className="social-buttons-container">
                    <a href="tel:02030266258" className="social-button" aria-label="Phone">
                      <i className="las la-phone-volume"></i>
                    </a>
                    <a
                      href="mailto:info@alisarprospects.training"
                      className="social-button"
                      aria-label="Email"
                    >
                      <i className="las la-at"></i>
                    </a>
                    <a
                      href="https://www.facebook.com/AlisarProspectsTrainingCIC/"
                      className="social-button"
                      aria-label="Facebook"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="lab la-facebook"></i>
                    </a>
                    <a
                      href="https://www.instagram.com/apt_cic/?hl=en-gb"
                      className="social-button"
                      aria-label="Instagram"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="lab la-instagram"></i>
                    </a>
                    <a
                      href="https://goo.gl/maps/xUqC1tn4ZAjJreax7"
                      className="social-button"
                      aria-label="Location"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="las la-map"></i>
                    </a>
                  </div>
                </div>
              </section>

              <div className="footer-links-grid">
                <div className="footer-links-section-container">
                  <h3 className="footer-links-heading">About APT</h3>
                  <ul className="footer-links">
                    <li>
                      <Link to="/about/mission-values">Mission & Values</Link>
                    </li>
                    <li>
                      <Link to="/about/leadership-team">Our Team</Link>
                    </li>
                    <li>
                      <Link to="/about/our-impact">Our Impact</Link>
                    </li>
                    <li>
                      <Link to="/about/partnerships">Partnerships</Link>
                    </li>
                  </ul>
                </div>

                <div className="footer-links-section-container">
                  <h3 className="footer-links-heading">Our Services</h3>
                  <ul className="footer-links">
                    <li>
                      <Link to="/training">Training</Link>
                    </li>
                    <li>
                      <Link to="/employment-support">Employment Support</Link>
                    </li>
                    <li>
                      <Link to="/community-projects">Community Projects</Link>
                    </li>
                    <li>
                      <Link to="/employment-support/success-stories">Success Stories</Link>
                    </li>
                  </ul>
                </div>

                <div className="footer-links-section-container">
                  <h3 className="footer-links-heading">Get Involved</h3>
                  <ul className="footer-links">
                    <li>
                      <Link to="/get-involved/volunteer">Volunteer With Us</Link>
                    </li>
                    <li>
                      <Link to="/get-involved/partner">Partner With Us</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact</Link>
                    </li>
                  </ul>
                </div>

                <div className="footer-links-section-container">
                  <h3 className="footer-links-heading">Legal</h3>
                  <ul className="footer-links">
                    <li>
                      <Link to="/privacy-policy">Privacy Policy</Link>
                    </li>
                    <li>
                      <Link to="/cookie-policy">Cookie Policy</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            
            <div className="footer-bottom">
              <div className="footer-bottom-content">
                <p className="copyright-text">
                  © {new Date().getFullYear()} Alisar Prospects Training CIC. All rights reserved.
                </p>
                <p className="footer-bottom-note">
                  A Community Interest Company dedicated to empowering London's communities
                </p>
              </div>
            </div>
          </div>
        );
    }
}

export default Footer;